import { inject } from "fw";
import { createFrom, createFromArray } from "fw-model";
import { PasswordStrengthProfile } from "models/utility";

import { Manager } from "./manager";

@inject
export class UtilityRepository {
    constructor(private s: Manager) {}

    public async saml2Metadata(url: string) {
        const res = await this.s.get("utility/saml2/metadatainfo", { url });
        return createFrom(SAML2MetadataInfoResult, res.body);
    }

    public async pgpInfo(keyText: string) {
        const res = await this.s.post<PgpPublicKeyInfo[]>("utility/pgpinfo", keyText);
        return createFromArray(PgpPublicKeyInfo, res.body);
    }

    async decrypt(data: string) {
        const res = await this.s.post<string>("utility/decrypt", data);
        return res.body;
    }

    async decryptPayloads(payloads: string[]) {
        const res = await this.s.post<string[]>("utility/decrypt-payload", payloads);
        return res.body;
    }

    async checkPasswordStrength(password: string) {
        const res = await this.s.post<PasswordStrengthProfile>("utility/check-password-strength", password);
        return res.body;
    }
}

export class SAML2MetadataInfoResult {
    MetadataUrl: string;
    IsFederation: boolean;
    EntityIds: string[];
}

export class PgpPublicKeyInfo {
    KeyId: string;
    UserIds: string[];
    Expires?: Date;
}

export class PgpPrivateKeyInfo {
    KeyId: string;
    UserIds: string[];
}
